import { createSlice } from '@reduxjs/toolkit';
import { AnalyticsDashboardResponse, getSezDashboard } from './SezActions';

interface ISezDashSlice {
  showColumnSettings: boolean;
  sezTopSearch: string;
  analyticsData: AnalyticsDashboardResponse | null;
  analyticsLoading: boolean;
  analyticsError: string | null;
}

const initialState: ISezDashSlice = {
  showColumnSettings: false,
  sezTopSearch: '',
  analyticsData: null,
  analyticsLoading: false,
  analyticsError: null,
};

export const sezDashboardSlice = createSlice({
  name: 'sezDashboard',
  initialState,
  reducers: {
    toggleColumnSettingsSezDash: (state, action) => {
      state.showColumnSettings = action.payload;
    },
    setSezTopSearchFilter: (state, action) => {
      state.sezTopSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSezDashboard.pending, (state) => {
        state.analyticsLoading = true;
        state.analyticsError = null;
      })
      .addCase(getSezDashboard.fulfilled, (state, action) => {
        state.analyticsLoading = false;
        state.analyticsData = action.payload;
      })
      .addCase(getSezDashboard.rejected, (state, action) => {
        state.analyticsLoading = false;
        state.analyticsError =
          (action.payload as any)?.message ?? 'Failed to load analytics';
      });
  },
});

export const { toggleColumnSettingsSezDash, setSezTopSearchFilter } =
  sezDashboardSlice.actions;

export default sezDashboardSlice.reducer;
